import React from 'react';
import ReactDOM from 'react-dom';
import './css/index.css';
import App from './App';

import { createBrowserHistory } from 'history';

const history = createBrowserHistory();
// Set up the browser history with the updated location
// (minus the # sign)
const path = (/#!(\/.*)$/.exec(window.location.hash) || [])[1];
if (path) {
  history.replace(path);
}

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);
